var map = {
	"./news-01.png": "3fca",
	"./news-01_2x.png": "1e9e",
	"./news-02.png": "ffdb",
	"./news-02_2x.png": "c816",
	"./news-03.png": "b576",
	"./news-03_2x.png": "1f34",
	"./news-04.png": "8ff5",
	"./news-04_2x.png": "7c77",
	"./news-05.png": "100b",
	"./news-05_2x.png": "1ec6",
	"./news-06.png": "cb28",
	"./news-06_2x.png": "bded",
	"./news-07.png": "cbe5",
	"./news-07_2x.png": "392e",
	"./news-08.png": "d584",
	"./news-08_2x.png": "5443",
	"./news-list": "7ecc",
	"./news-list.json": "7ecc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f544";